import { api } from "./client";
import type { ApiResponse } from "./types";

export interface TicketTier {
  id: string;
  eventId: string;
  name: string;
  description: string | null;
  priceCents: number;
  currency: string;
  quantityAvailable: number; // -1 = unlimited
  saleState: string;
  urgencyHint: string | null;
  sortOrder: number;
  isActive: boolean;
}

export interface OrderTicket {
  id: string;
  ticketCode: string;
  attendeeName: string | null;
  status: string;
  tierId: string;
}

export interface Order {
  id: string;
  status: string;
  eventId: string;
  eventTitle: string;
  totalCents: number;
  currency: string;
  tickets: OrderTicket[];
}

export function listTiers(eventId: string) {
  return api.get<ApiResponse<{ tiers: TicketTier[] }>>(`/events/${eventId}/tiers`);
}

export function createTier(
  eventId: string,
  body: { name: string; priceCents: number; quantityTotal: number; description?: string },
) {
  return api.post<ApiResponse<TicketTier>>(`/events/${eventId}/tiers`, body);
}

export interface MyTicket {
  id: string;
  ticketCode: string;
  status: string;
  attendeeName?: string | null;
  event?: { id: string; title: string; eventDate: string; slug?: string };
  tier?: { name: string };
  [key: string]: unknown;
}

export function myTickets() {
  return api.get<ApiResponse<{ upcoming: MyTicket[]; past: MyTicket[] }>>("/users/me/tickets");
}

export function createOrder(
  eventId: string,
  body: {
    items: { tierId: string; quantity: number }[];
    /** One entry per seat, in item order; userId assigns the seat's
     *  ticket to a member of the group, null keeps it with the buyer. */
    memberAssignments?: (string | null)[];
    /** Buy for this circle instead of the household. Needs an assigned seat. */
    circleId?: string;
    /** One per checkout; a retry with it returns the first order, as it is now. */
    idempotencyKey?: string;
  },
) {
  return api.post<ApiResponse<{ order: Order }>>(`/events/${eventId}/orders`, body);
}
